import React, { FC, ReactNode } from 'react';

import { useIntl } from 'react-intl';

import EmptyState from 'components/empty-state';
import { BackArrowHistory } from 'components/navigation/back-arrow';
import { routes } from 'utils/routing';

import { RecentOrderTitle, Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<IOrdersEmptyProps> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <BackArrowHistory />
      <RecentOrderTitle>{formatMessage({ id: 'recentOrders' })}</RecentOrderTitle>
      {children}
      <Wrap>
        <EmptyState
          header={formatMessage({ id: 'noOrderYet' })}
          subheader={formatMessage({ id: 'recentOrdersEmptySubHeader' })}
          linkTo={routes.menu}
          linkText={formatMessage({ id: 'startOrder' })}
        />
      </Wrap>
    </div>
  );
};

export default OrdersEmpty;
